import { render, staticRenderFns } from "./DepartmentModal.vue?vue&type=template&id=c9eefe5a&scoped=true&"
import script from "./DepartmentModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9eefe5a",
  null
  
)

export default component.exports